export const FOOTER_HEIGHT = 80;

export const SCROLL_TIMEOUT = 300;

export const SCROLL_OFFSET = 30;
